import { CITATION_LIST_FIELD, type DocumentCitationState,generateObjectId } from '@alpod-ai-writer/shared';
import { useCallback } from 'react';

import { useDocumentEditor } from './useDocumentEditor.hook';
import { useYDocMap } from './useYDocText.hook';

export function useCitationList() {
    const editor = useDocumentEditor();
    const { entries, docMap, addEntry } = useYDocMap<DocumentCitationState>(editor.yjsProvider.document, CITATION_LIST_FIELD);

    const addCitation = useCallback((label: string) => {
        const id = generateObjectId();

        addEntry(id, {
            userLabel: label,
            citation: '',
            source: ''
        });

        return { id };
    }, [ addEntry ]);

    return {
        citationList: entries,
        citationMap: docMap,
        addCitation
    };
}
